import styles from "./style.module.css";
import { Box, Typography } from "@mui/material";
import React from "react";
import { Add } from "@mui/icons-material";
import Alert from "../alert";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveUserSkill,
  setUserSkills,
} from "../../../../../../../store/slices/userSlice";
import { setEmptySkillIndex } from "../../../../../../../store/slices/profile/skillSlice";
import checkSkillComplete from "../../../../../../../helpers/checkSkillComplete";

const Skill = ({ skill, index }) => {
  const { theme, darkMode } = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userSkills } = useSelector((state) => state.user);

  const isSkillComplete = checkSkillComplete({
    name: skill?.name,
    description: skill?.description,
    level: skill?.level,
    startedTrainingDate: skill?.startedTrainingAge,
  });

  // console.log(skill.created, "skill.created");

  const handleItemClick = () => {
    if (!skill?.created) {
      dispatch(setEmptySkillIndex(index));
      navigate("/add-skill");
    }
    if (Object.keys(skill).includes("isActive")) {
      const filteredSkills = userSkills.map((item) => {
        if (skill?.id === item.id) {
          return { ...skill, isActive: true };
        } else if (Object.keys(item).includes("isActive")) {
          return { ...item, isActive: false };
        } else {
          return item;
        }
      });
      dispatch(setUserSkills(filteredSkills));
      dispatch(setActiveUserSkill({ ...skill, isActive: true }));
    }
  };

  return (
    <Box className={styles.skill} key={index}>
      <Box
        className={styles.skillNum}
        sx={{
          background: skill?.isActive
            ? theme.palette.primary.main
            : theme.palette.lightgrey.lightgrey00,
        }}
        onClick={handleItemClick}
      >
        {skill?.isActive ? (
          <img src={skill?.activeImage} alt="" />
        ) : !skill?.created ? (
          <Add
            sx={{
              color: darkMode
                ? theme.palette.primary.purpel100
                : theme.palette.primary.main,
              fontSize: "32px",
            }}
          />
        ) : !skill?.isActive && skill?.created ? (
          <img src={skill?.inActiveImage} alt="" />
        ) : (
          <></>
        )}
      </Box>
      <Box className={styles.text}>
        <Typography
          variant="h4"
          sx={{
            color: skill?.isActive
              ? darkMode
                ? "#FFF"
                : theme.palette.primary.main
              : darkMode
              ? theme.palette.darkgrey.darkgrey300
              : theme.palette.darkgrey.darkgrey600,
            fontSize: {
              xs: "12px",
            },
            fontWeight: "500",
          }}
        >
          {!skill?.created ? "Add New" : skill?.category}
        </Typography>
      </Box>
      <Alert
        type={
          isSkillComplete
            ? "complete"
            : skill?.created
            ? "notComplete"
            : "notAdded"
        }
      />
    </Box>
  );
};

export default Skill;
